'use client';

import Composer from '@/common/Composer';
import { useShowComposerTreatment } from '~/context/composer/ComposerContext';

export default function VdpComposerUi() {
  const showComposerTreatment = useShowComposerTreatment();

  if (!showComposerTreatment) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 max-md:-translate-y-[100px]">
      <Composer inputPlaceholder="" />
    </div>
  );
}
